import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Observable } from "rxjs";
import { Contract } from "../../companies/_types/contract";

@Injectable({
    providedIn: 'root',
})

export class PublicContractService extends Service<Contract> {
  public override type = 'contract';
  public override url = 'attendance/public/contract'; 

  public override get(id: string): Observable<Contract> {
    let url = this.getAPIUrl() + "/" + id;
    return this.http.get<Contract>(url);
  }
}
